var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconFoguete(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 60,
    viewBox: "0 0 44 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1303 51.6667C8.97959 58.286 18.9049 61.511 21.0556 54.8916L11.1303 51.6667ZM22.392 50.7787C25.6995 51.8533 28.0977 53.8517 29.5868 56.7738C42.1574 46.2236 42.1177 40.722 37.6908 37.4557C46.4202 27.4853 42.9889 9.90769 33.0209 1.18028C19.8298 2.38285 6.72193 14.5865 7.9193 27.7824C2.42089 27.8238 -0.846395 32.2508 3.12219 48.175C6.04473 46.6852 9.15974 46.4776 12.4672 47.5523L12.2318 48.3914L22.0898 51.5944L22.392 50.7787Z",
    stroke: "#353435",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFoguete);
export default __webpack_public_path__ + "static/media/icon_foguete.0fc421549829c0d7bc51f50d47303640.svg";
export { ForwardRef as ReactComponent };